import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AuthContext from '../../components/auth-context';
import TicketCommentsApi from '../../api/ticket-comments';
import TicketComment from '../../types/ticket-comment';

function TicketDetail() {
  let { id } = useParams();
  const context = useContext(AuthContext);
  const [comments, setComments] = useState<TicketComment[]>([]);

  function formatDateTime(dateTime: number | string) {
    const s = dateTime.toString();

    const year = s.slice(0, 4);
    const month = s.slice(4, 6);
    const day = s.slice(6, 8);
    const hour = s.slice(8, 10);
    const minute = s.slice(10, 12);

    return `${year}/${month}/${day} - ${hour}:${minute}`;
  }

  useEffect(() => {
    new TicketCommentsApi(context)
      .get(Number(id))
      .then((res) => setComments(res))
      .catch(console.error);
  }, [id]);

  if (!comments) return null;

  return (
    <div className="container py-5 mt-2" dir="rtl">
      <div className="row g-4">
        {comments.map((comment) => (
          <div key={comment.id} className="col-12">
            <div
              className="card shadow-sm border-0"
              style={{
                borderRadius: '14px',
                overflow: 'hidden',
              }}
            >
              <div className="card-body">
                <p
                  className="mb-0"
                  style={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: '1.9',
                    fontSize: '15px',
                  }}
                >
                  {comment.description}
                </p>
              </div>

              <div
                className="px-4 py-2 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  borderTop: '1px solid #eee',
                  fontSize: '13px',
                  color: '#6c757d',
                }}
              >
                <span>
                  توسط{' '}
                  <strong style={{ color: '#495057' }}>
                    {comment.userDisplayName || 'کاربر سیستم'}
                  </strong>
                </span>

                <span>{formatDateTime(comment.dateTime)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TicketDetail;
